window.Products.WallArt.ArtPrint = function() {

};

window.Products.WallArt.ArtPrint.inherits(window.Products.WallArt.ArtProduct);

window.Products.WallArt.ArtPrint.id = 38;
window.Products.WallArt.ArtPrint.saveId = 37;
window.Products.WallArt.ArtPrint.slug = 'art-print';
window.Products.WallArt.ArtPrint.has_3d = true;
window.Products.WallArt.ArtPrint.use_variants = true;
window.Products.WallArt.ArtPrint.dpi = 300;
window.Products.WallArt.ArtPrint.texture = new Image(1024, 1024);

window.Products.WallArt.ArtPrint.prototype.set3dProperties = function(modelViewer) {
	modelViewer.camera_light.intensity = 0.2;
	modelViewer.camera_light.color = {r: 0.8, g: 0.8, b: 0.8};
	this.updateThreeTexture(modelViewer);
};

window.Products.WallArt.ArtPrint.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
};

window.Products.WallArt.ArtPrint.prototype.addBorders = function(value, modelViewer, width, height) {
	if(!modelViewer.textureImage){return;}
	var ctx = modelViewer.texture.image.getContext('2d');
	var x, y, inch;
	var r = width / height;

	x = 0;

	if(r > 1){
		inch = 1024 / width;
		height = this.parent.static.magic_size / r;
	} else {
		inch = 1024 / height;
		height = this.parent.static.magic_size * r;	
	}

	width = this.parent.static.magic_size;

	y = (this.parent.static.magic_size - height) / 2;

	ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	ctx.fillStyle = "white";
	ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

	var x2, y2, border_x = 0, border_y = 0, width2, height2;

	if(value){
		border_x = (value * inch);
		border_y = (value * inch);
		if(r > 1){
			border_x *= r;
		} else {
			border_y *= r;
		}
	}

	width2 = width - border_x * 2;
	height2 = height - border_y * 2;
	x2 = border_x;
	y2 = y + border_y;

	ctx.drawImage(modelViewer.textureImage, x, y, width, height, x2, y2, width2, height2);

	modelViewer.texture.needsUpdate = true;
};

window.Products.WallArt.ArtPrint.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.4;
	controls.maxDistance = 2.4;
	controls.minPolarAngle = Math.PI/2;
	controls.maxPolarAngle = Math.PI/2;
	controls.minAzimuthAngle = -Math.PI/2.5;
	controls.maxAzimuthAngle = Math.PI/2.5;
};